import { render } from "./AddSecteurActivite.vue?vue&type=template&id=5a3bf1fa&ts=true"
import script from "./AddSecteurActivite.vue?vue&type=script&lang=ts"
export * from "./AddSecteurActivite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__